/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbListAssignmentGroupResponse {
    getFixupPrototypeFunction() { return ServiceNowCmdbListAssignmentGroupResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbListAssignmentGroupResponse>): ServiceNowCmdbListAssignmentGroupResponse {
        let obj = Object.assign(new ServiceNowCmdbListAssignmentGroupResponse(), model);
        ServiceNowCmdbListAssignmentGroupResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbListAssignmentGroupResponse>): ServiceNowCmdbListAssignmentGroupResponse {
        if (!model) return null;
        return ServiceNowCmdbListAssignmentGroupResponse.newInstance(<ServiceNowCmdbListAssignmentGroupResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbListAssignmentGroupResponse) {
        if (!obj) return;

        models.ServiceNowCmdbListAssignmentGroupResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbListAssignmentGroupResponse): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbListAssignmentGroupResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let val of this.results) {
                models.ServiceNowCmdbAssignmentGroup.fixupPrototype(val);
            }
        }
    }

    /**
     * List of ServiceNow User Groups
     */
    results: Array<models.ServiceNowCmdbAssignmentGroup>;

}
